var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('V-row',[_c('v-col',{attrs:{"md":"12"}},[_c('SettingItem',{attrs:{"collection":"author","items":_vm.author,"itemHeader":_vm.authorItemHeader},on:{"loadData":_vm.loadData}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }